import Vue from 'vue'
import Main from './Notification'
const NotificationConstructor = Vue.extend(Main)

const Notification = async function(options) {
    options = options || {}

    return new Promise(() => {
        var instance = new NotificationConstructor({
            data: options
        })
        instance.$mount()
    })
}

export default Notification
